package com.evoapps.evoshift.ui.reports

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

/** Downloads the file through a temporary link (the tap that asked for it allows the download). */
class WebFileSaver : FileSaver {
    override fun save(file: ExportFile) {
        val blob = Blob(arrayOf(file.text), BlobPropertyBag(type = "${file.mimeType};charset=utf-8"))
        val url = URL.createObjectURL(blob)
        val link = document.createElement("a") as HTMLAnchorElement
        link.href = url
        link.download = file.name
        link.style.display = "none"
        document.body?.appendChild(link)
        link.click()
        link.remove()
        window.setTimeout({ URL.revokeObjectURL(url) }, 1_000)
    }
}
